import config from "config-base";

export const CustomerSupportLinks = [
  { title: 'Contact Us', href: config.contactUsUrl },
  { title: 'Track Order', href: config.orderTrackingUrl },
  { title: 'FAQ', href: config.faqUrl },
  { title: 'Account', href: config.signInUrl },
  { title: 'Bullseye Bucks', href: config.bullseyeBucksAboutUrl },
  { title: 'Gift eCards', href: config.giftCardsUrl },
];

export const ShippingServiceLinks = [
  { title: 'Build Custom Airgun', href: config.airGunBuilderUrl },
  { title: 'Product Finder', href: config.productFinderUrl },
  { title: 'Hunting Laws by State', href: config.airgunMapUrl },
  { title: 'Brands', href: config.airgunsByBrandUrl },
  { title: 'Catalog', href: config.requestCatalogUrl },
  { title: 'Safety', href: config.airgunSafetyUrl },
];

export const CompanyLinks = [
  { title: 'About Us', href: config.aboutUsUrl },
  { title: 'Resources', href: config.airgunResourcesUrl },
  { title: 'Affiliate Program', href: config.affiliateProgramUrl },
  { title: 'Become a Seller', href: config.sellerUrl },
  { title: 'Dealers', href: config.dealersUrl, rel: 'noreferrer' },
  { title: 'Careers', href: config.careersUrl },
];
